import { QueryHookOptions } from '@apollo/client';
import gql from 'graphql-tag';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import { QueuedItemStatus } from '../../models/QueuedItemStatus';
import {
  GoogleAdsRequestBatchGq,
  GoogleAdsRequestBatchGqProps,
} from '../../models/GoogleAdsRequestBatchGq';

export default function useGetGoogleAdsRequestBatchesGq(
  command: CommandGq,
  options: QueryHookOptions<ResponseGq, VariablesGq> = {}
) {
  const query = useCustomQuery<ResponseGq, VariablesGq>(gqTag, {
    ...options,
    variables: { command },
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getGoogleAdsRequestBatches ?? {
      batches: [],
      page: 1,
      totalCount: 1,
    },
  };
}

const gqTag = gql`
  query GetGoogleAdsRequestBatches($command: GetGoogleAdsRequestBatchCommandCommand!) {
    projects {
      getGoogleAdsRequestBatches(command: $command) {
        batches {
            ${GoogleAdsRequestBatchGqProps}
        }
        page
        totalCount
      }
    }
}`;

interface VariablesGq {
  command: CommandGq;
}

export interface CommandGq {
  requestId: number;
  projectId: number;
  page: number;
  itemsPerPage: number;
  statusFilter?: QueuedItemStatus;
}

interface ResponseGq {
  projects: {
    getGoogleAdsRequestBatches: {
      batches: GoogleAdsRequestBatchGq[];
      page: number;
      totalCount: number;
    };
  };
}
